import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { typographyClasses } from './typographyClasses';

export const allowedBoldVariants = ['body1', 'body2'];

export const TypographyRoot = styled(Typography, {
  name: 'AFTypography',
  shouldForwardProp: prop => prop !== 'weight' && prop !== 'isBoldAllowed'
})(({ theme, weight, isBoldAllowed }) => ({
  ...(isBoldAllowed && {
    fontWeight: weight === 'bold' ? 400 : 300
  }),
  [`&.${typographyClasses.hero1}`]: {
    ...theme.typography.hero1
  }
}));
